import { useParams } from 'react-router-dom';

import { AppCreateUserBadgePage } from '~/components/pages/AppCreateUserBadgePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateUserBadgeRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCreateUserBadgePage appId={appId} />
    </DashboardTemplate>
  );
};
